module.exports = __webpack_public_path__ + "static/media/offer-expired-image@1x.edf0b004.png";